import { render, staticRenderFns } from "./IdentificationsMultiple.vue?vue&type=template&id=7adfc56d&scoped=true&"
import script from "./IdentificationsMultiple.vue?vue&type=script&lang=ts&"
export * from "./IdentificationsMultiple.vue?vue&type=script&lang=ts&"
import style0 from "./IdentificationsMultiple.vue?vue&type=style&index=0&id=7adfc56d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfc56d",
  null
  
)

export default component.exports